<script setup lang="ts">
import DSContainer from '~/components/ds/Container.vue'

const { t } = useI18n()
const localePath = useLocalePath()

const categories = computed(() => [
  { key: 'iphone', label: t('footer.shop.iphones'), icon: 'i-lucide-smartphone', to: '/shop?category=iphone' },
  { key: 'ipad', label: t('footer.shop.ipads'), icon: 'i-lucide-tablet', to: '/shop?category=ipad' },
  { key: 'macbook', label: t('footer.shop.macs'), icon: 'i-lucide-laptop', to: '/shop?category=macbook' },
  { key: 'watch', label: t('footer.shop.watch'), icon: 'i-lucide-watch', to: '/shop?category=watch' },
  { key: 'accessories', label: t('footer.shop.accessories'), icon: 'i-lucide-headphones', to: '/shop?type=accessory' },
])
</script>

<template>
  <section class="bg-white py-10 dark:bg-gray-900 sm:py-12" :aria-labelledby="'shop-categories-title'">
    <DSContainer>
      <div class="mb-7 flex items-end justify-between gap-4">
        <div>
          <h2 id="shop-categories-title" class="text-2xl font-bold text-gray-900 dark:text-white sm:text-3xl">
            {{ t('home.categories.title') }}
          </h2>
          <p class="mt-2 text-gray-600 dark:text-gray-400">{{ t('home.categories.subtitle') }}</p>
        </div>
        <NuxtLink :to="localePath('/shop')" class="hidden text-sm font-semibold text-brand-700 hover:text-brand-800 sm:inline-flex sm:items-center sm:gap-1 dark:text-brand-300">
          {{ t('products.viewAll') }}
          <UIcon name="i-lucide-arrow-right" class="size-4" />
        </NuxtLink>
      </div>

      <div class="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        <NuxtLink
          v-for="category in categories"
          :key="category.key"
          :to="localePath(category.to)"
          class="group flex min-h-28 flex-col items-center justify-center rounded-xl border border-gray-200 bg-gray-50 p-4 text-center transition-colors hover:border-brand-300 hover:bg-brand-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600 dark:border-gray-700 dark:bg-gray-800 dark:hover:border-brand-700 dark:hover:bg-brand-950/30"
        >
          <span class="mb-3 flex size-11 items-center justify-center rounded-xl bg-white text-brand-700 shadow-sm dark:bg-gray-900 dark:text-brand-300">
            <UIcon :name="category.icon" class="size-6" />
          </span>
          <span class="font-semibold text-gray-900 group-hover:text-brand-800 dark:text-white dark:group-hover:text-brand-200">{{ category.label }}</span>
        </NuxtLink>
      </div>
    </DSContainer>
  </section>
</template>
